import { sdk } from "lib/dato";
import { InferGetStaticPropsType } from "next";
import { Layout } from "components/layout";
import { Widget } from "@typeform/embed-react";
import Link from "next/link";
import { useCallback, useMemo, useState } from "react";
import { legalLinks } from "../../components/shady-grove-dialog";

export default function Quiz({
  site,
  page,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  let timesOnFirstQuestion = 0;
  const [inCoverPage, setInCoverPage] = useState(true);

  const widgetComponent = useMemo(
    () => (
      <Widget
        id="PzwAoDw5"
        autoFocus={true}
        style={{
          width: "100%",
          height: "100vh",
        }}
        inlineOnMobile={true}
        iframeProps={{
          style: "transform: translateZ(0px); border-radius: 0px !important",
        }}
        className="quiz-form"
        onQuestionChanged={(question: { ref: string }) => {
          setInCoverPage(false); // put in a callback so this doesn't trigger re-rendering
          window.gtag("event", "quiz_question_change", {
            screen_name: "quiz",
            question: question?.ref,
          });

          // First question ID is: 9c27b78e-323a-40d7-8337-a1c28308bd50
          if (
            question?.ref === "9c27b78e-323a-40d7-8337-a1c28308bd50" &&
            timesOnFirstQuestion === 0
          ) {
            window.gtag("event", "quiz_started", {
              screen_name: "quiz",
            });
            timesOnFirstQuestion++;
          }
        }}
        onSubmit={(event: any) => {
          window.gtag("event", "quiz_submit", {
            screen_name: "quiz",
          });
        }}
      />
    ),
    []
  );

  return (
    <Layout
      showLogo={true}
      showNavbar={false}
      showFooter={false}
      site={site}
      page={page.quiz?.seo}
    >
      <div className="relative">
        <div className="h-screen">
          {widgetComponent}
          <TermsTextDesktop inCoverPage={inCoverPage} />
        </div>
        <TermsTextMobile inCoverPage={inCoverPage} />
      </div>
    </Layout>
  );
}

const TermsTextDesktop = ({ inCoverPage }: { inCoverPage: boolean }) => {
  return (
    <div
      className={`z-1000 absolute bottom-0 left-0 w-1/2 text-center p-4 text-xs md:text-sm opacity-0 animate-fadeIn text-gray-500 ${
        inCoverPage ? "hidden lg:block" : "hidden"
      }`}
    >
      By continuing, you agree to the{" "}
      <Link href={legalLinks.terms.href}>
        <a target="_blank" className="underline">
          {legalLinks.terms.label}
        </a>
      </Link>{" "}
      and{" "}
      <Link href={legalLinks.privacy.href}>
        <a target="_blank" className="underline">
          {legalLinks.privacy.label}
        </a>
      </Link>
      .
    </div>
  );
};

const TermsTextMobile = ({ inCoverPage }: { inCoverPage: boolean }) => {
  return (
    <div
      className={`absolute top-full w-full text-center p-4 text-xs md:text-xs opacity-0 animate-fadeIn text-gray-500 ${
        inCoverPage ? "block lg:hidden" : "hidden"
      }`}
    >
      By continuing, you agree to the{" "}
      <Link href={legalLinks.terms.href}>
        <a target="_blank" className="underline">
          {legalLinks.terms.label}
        </a>
      </Link>{" "}
      and{" "}
      <Link href={legalLinks.privacy.href}>
        <a target="_blank" className="underline">
          {legalLinks.privacy.label}
        </a>
      </Link>
      .
    </div>
  );
};

export const getStaticProps = async () => {
  return {
    props: {
      site: await sdk.SiteSettings(),
      page: await sdk.QuizPage(),
    },
    revalidate: 10,
  };
};
